// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_pM3W1","btn":"btn_GiKT1"};